import styled, { css } from 'styled-components';

import { ReactComponent as StarSvg } from '../../../../assets/icons/star.svg';
import { FileType } from '../../../../chat/utils/files';
import colors from '../../../../styles/colors';

const metaTextStyle = css`
  font-size: 12px;
  color: ${colors.shades.gamma10};
`;

const DocumentRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background-color: ${colors.base.alpha};
  border-bottom: 1px solid ${colors.shades.secondary10};
  cursor: default;

  &:hover {
    background-color: ${colors.shades.secondary10};
  }
`;

const ThumbnailContainer = styled.div`
  position: relative;
  width: 44px;
  height: 44px;
  margin-right: 12px;
  flex-shrink: 0;
`;

const ThumbnailWrapper = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 6px;
  overflow: hidden;
  background-color: ${colors.shades.secondary7};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 0.85;
  }
`;

const SavedBadge = styled(StarSvg)`
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 14px;
  height: 14px;
  pointer-events: none;
`;

const ThumbnailStyle = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ThumbnailImage = styled.img`
  ${ThumbnailStyle}
`;

const VideoThumbnail = styled.video`
  ${ThumbnailStyle}
`;

const getThumbnailBg = ($type) => {
  if ($type === FileType.VIDEO) return colors.shades.primary3;
  if ($type === FileType.PDF) return colors.shades.danger2;
  return colors.shades.secondary7;
};

const getThumbnailIconColor = ($type) => {
  if ($type === FileType.VIDEO) return colors.base.alpha;
  if ($type === FileType.PDF) return colors.base.danger;
  return colors.base.secondary;
};

const ThumbnailIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ $type }) => getThumbnailBg($type)};

  svg {
    width: 22px;
    height: 22px;
    color: ${({ $type }) => getThumbnailIconColor($type)};
  }
`;

const VideoPreviewContent = styled.div`
  background-color: ${colors.base.beta};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoPlayer = styled.video`
  width: 100%;
  max-height: 80vh;
`;

const NameCell = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding-right: 5px;
`;

const NameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

const FileMetaLabel = styled.span`
  font-size: 11px;
  color: ${colors.shades.gamma10};
  white-space: nowrap;
`;

const FileName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.base.secondary2};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RenameInput = styled.input`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.base.secondary2};
  border: 1px solid ${colors.base.secondary};
  border-radius: 4px;
  padding: 2px 6px;
  flex: 1;
  min-width: 0;
  outline: none;
  margin-right: 4px;
`;

const UploadedCell = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
`;

const UploadedDate = styled.span`
  ${metaTextStyle}
`;

const UploadedBy = styled.span`
  font-size: 11px;
  color: ${colors.shades.gamma11};
  margin-top: 1px;
`;

export {
  DocumentRow,
  ThumbnailContainer,
  ThumbnailWrapper,
  VideoPlayer,
  SavedBadge,
  ThumbnailImage,
  VideoThumbnail,
  ThumbnailIcon,
  VideoPreviewContent,
  NameCell,
  NameRow,
  FileMetaLabel,
  FileName,
  RenameInput,
  UploadedCell,
  UploadedDate,
  UploadedBy,
};
